module.exports = __webpack_public_path__ + "static/media/instructor-what-to-expect-next.91040731.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-what-to-expect-next.png
// module id = 2592
// module chunks = 0